import * as types from "../../constants";
const initState = {
    rows: "",
    columns: "",
    options: "",
}

export default function reducer(state = initState, actions) {
    switch (actions.type) {
        case types.CONF_GEN_RESTART_RESPONSE:
            console.log('reducers conf restarting response');
            return {
                rows: "",
                columns: "",
                options: "",
            };

        case types.CONF_GEN_LIST_SUCCESS:
            console.log('reducers conf gen list data');
            console.log(actions.response);
            return {
                ...state,
                rows: actions.response.rows,
                columns: actions.response.columns,
                options: actions.response.options,
            };

        case types.CONF_GEN_LIST_FAILURE:
            console.log('reducers conf gen list failure');
            return {
                ...state,
                rows: [],
                columns: [],
                options: [],
                error: 'Error al cargar los datos'
            };

        case types.CONF_GEN_CREATE_SUCCESS:
            console.log('reducers conf gen create success');
            return {
                ...state,
                rows: actions.response.rows,
                columns: actions.response.columns,
                options: actions.response.options,
            };

        case types.CONF_GEN_CREATE_FAILURE:
            console.log('reducers conf gen create failure');
            return {
                ...state,
                error: 'Error al crear el elemento'
            };

        case types.CONF_GEN_UPDATE_SUCCESS:
            console.log('reducers conf gen update success');
            return {
                ...state,
                rows: actions.response.rows,
                columns: actions.response.columns,
                options: actions.response.options,
            };

        case types.CONF_GEN_UPDATE_FAILURE:
            console.log('reducers conf gen update failure');
            return {
                ...state,
                error: 'Error al actualizar el elemento'
            };

        case types.CONF_GEN_DELETE_SUCCESS:
            console.log('reducers conf gen delete success');
            return {
                ...state,
                rows: actions.response.rows,
                columns: actions.response.columns,
                options: actions.response.options,
            };

        case types.CONF_GEN_DELETE_FAILURE:
            console.log('reducers conf gen delete failure');
            return {
                ...state,
                error: 'Error al eliminar el elemento'
            };

        default:
            return state;
    }
}
